import { api } from "@/api"

type RequestPasswordResetIn = {
  merchantId: string
  email: string
}

export const requestPasswordReset = async (
  params: RequestPasswordResetIn
) => {
  const { body } = await api.post<{ message: string }>(
    "/auth/request-password-reset/",
    { body: params, authenticated: false }
  )
  return body
}
